import { render, staticRenderFns } from "./CameraComponents.vue?vue&type=template&id=16153fae&scoped=true"
import script from "./CameraComponents.vue?vue&type=script&lang=js"
export * from "./CameraComponents.vue?vue&type=script&lang=js"
import style0 from "./CameraComponents.vue?vue&type=style&index=0&id=16153fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16153fae",
  null
  
)

export default component.exports